import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/core/assets/icons/icon-edit.svg'
import _imports_1 from '@/core/assets/icons/icon-trash.svg'
import _imports_2 from '@/core/assets/icons/icon-dark-check.svg'
import _imports_3 from '@/core/assets/icons/icon-close.svg'
import _imports_4 from '@/core/assets/illustrations/illustration-delete.svg'


const _withScopeId = n => (_pushScopeId("data-v-6d244f40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "group-name-wrapper" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "actions" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "edit"
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "remove"
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "actions no-hidden"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "edit"
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "close"
}, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "keyword-count" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "delete",
  class: "header"
}, null, -1))
const _hoisted_20 = { class: "content" }
const _hoisted_21 = { class: "text" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Confirm Delete ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_list_table = _resolveComponent("list-table")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_list_table, {
      header: _ctx.header,
      items: _ctx.items,
      loading: _ctx.loading,
      "is-loaded": _ctx.isLoaded,
      footer: _ctx.tableFooter,
      onLoadMore: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('loadMore')))
    }, {
      "body-row": _withCtx(({ item }) => [
        _createElementVNode("td", {
          style: _normalizeStyle({ width: _ctx.header[0].width }),
          class: _normalizeClass({
          'edit-mode': item.id === _ctx.readOnlyItem,
          selected: _ctx.selectedGroupRow === item.id,
        })
        }, [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.showCheckbox)
              ? (_openBlock(), _createBlock(_component_checkbox, {
                  key: 0,
                  value: _ctx.selectedRowItems,
                  name: "deneme",
                  "onUpdate:modelValue": ($event: any) => (_ctx.$emit('setSelectedRowItems', item))
                }, null, 8, ["value", "onUpdate:modelValue"]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("button", {
              class: "group-name",
              onClick: _withModifiers(($event: any) => (_ctx.$emit('selectedGroupItem', item)), ["stop"])
            }, _toDisplayString(item.name), 9, _hoisted_2), [
              [_vShow, item.id !== _ctx.readOnlyItem]
            ]),
            _withDirectives(_createElementVNode("input", {
              class: "input",
              ref: 
              (el) => {
                _ctx.inputs[item.id] = el;
              }
            ,
              value: item.name
            }, null, 8, _hoisted_3), [
              [_vShow, item.id === _ctx.readOnlyItem]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                class: "button",
                onClick: ($event: any) => (_ctx.editKeywordGroup(item))
              }, _hoisted_7, 8, _hoisted_5),
              _createElementVNode("button", {
                class: "button",
                onClick: ($event: any) => (_ctx.removeGroup(item))
              }, _hoisted_10, 8, _hoisted_8)
            ], 512), [
              [_vShow, !_ctx.readOnlyItem]
            ]),
            (_ctx.readOnlyItem === item.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("button", {
                    class: "button",
                    onClick: ($event: any) => (_ctx.saveChanges(item))
                  }, _hoisted_14, 8, _hoisted_12),
                  _createElementVNode("button", {
                    class: "button",
                    onClick: ($event: any) => (_ctx.cancelChanges(item))
                  }, _hoisted_17, 8, _hoisted_15)
                ]))
              : _createCommentVNode("", true)
          ])
        ], 6),
        _createElementVNode("td", {
          style: _normalizeStyle({ width: _ctx.header[1].width }),
          class: _normalizeClass({ selected: _ctx.selectedGroupRow === item.id })
        }, [
          _createElementVNode("div", _hoisted_18, _toDisplayString(item.keywordCount), 1)
        ], 6)
      ]),
      tfoot: _withCtx(() => [
        _renderSlot(_ctx.$slots, "tfoot", {}, undefined, true)
      ]),
      _: 3
    }, 8, ["header", "items", "loading", "is-loaded", "footer"]),
    (_ctx.openModalStatus)
      ? (_openBlock(), _createBlock(_component_base_modal, {
          key: 0,
          onConfirm: _ctx.confirm,
          onClose: _ctx.close,
          class: "modal",
          "main-button-color": "var(--color-warning)"
        }, {
          header: _withCtx(() => [
            _hoisted_19
          ]),
          content: _withCtx(() => [
            _createElementVNode("section", _hoisted_20, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.modalTitle), 1),
              _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.modalContent), 1)
            ])
          ]),
          "button-content": _withCtx(() => [
            _hoisted_22
          ]),
          _: 1
        }, 8, ["onConfirm", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}